/*
 * this.$store.dispatch('USER_LOGIN_ACTION', this.loginViewModel)
 * this.$store.dispatch('USER_LOGOUT_ACTION')
 * this.$store.state.login.userInfo
 */
'use strict'

const loginStore = {}

/* @usage : store state data shcema
            this.$store.state.login  */
loginStore.state = {
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {
    'name': '',
    'token': '',
    'avatar': ''
  }
}

/* @usage : unit operation
   this.$store.commit('USER_LOGIN') */
loginStore.mutations = {
  'USER_LOGIN' (state, userInfo, keys) {
    if (keys && keys.length > 0) {
      keys.forEach((key) => {
        state.userInfo[key] = userInfo[key]
      })
    } else {
      state.userInfo = userInfo
    }
    sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo))
  },
  'USER_LOGOUT' (state) {
    state.userInfo = {
      // 'userid': '',
      'name': '',
      'token': '',
      'avatar': ''
    }
    sessionStorage.removeItem('userInfo')
  }
}

/* @usage : based on state ,  return state's length or filter state data */
loginStore.getters = {

}

/* @usage : basic the operation for view component , this.$store.dispatch('USER_LOGIN') */
loginStore.actions = {
  'USER_LOGIN_ACTION' ({ commit }, obj, keys) {
    return new Promise((resolve, reject) => {
      commit('USER_LOGIN', obj, keys)
      resolve()
    })
  },
  'USER_LOGOUT_ACTION' ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('USER_LOGOUT')
      resolve()
    })
  }
}

export default loginStore



// WEBPACK FOOTER //
// ./src/pages/login/services/login.store.js